import { render, staticRenderFns } from "./OrderHoldModal.vue?vue&type=template&id=dcbcd7d6&"
import script from "./OrderHoldModal.vue?vue&type=script&lang=js&"
export * from "./OrderHoldModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderHoldModal.vue?vue&type=style&index=0&id=dcbcd7d6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports